export const ROUTE_LIST = "routeList";
export const STOP_LIST = "stopList";
export const ROUTE_REQUEST_STATUS = "routeRequestStatus"
export const STOP_REQUEST_STATUS = "stopRequestStatus"